export const colors = {
  primaryColor : "#71eb00",
  secondaryColor : "#181818",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(107deg,rgba(0,0,0,.6) 19.85%,rgba(113,235,0,.24) 75.31%,rgba(113,235,0,.6) 100.44%)",
darkColor:"#3fa203"
}